<template>
  <div class="page-overview-list">
    <div class="overview-results">
      <h1>Anfragen</h1>
      <template
        v-if="matcherRequests.results && matcherRequests.results.length"
      >
        <div
          v-for="(request, i) in matcherRequests.results"
          :key="i"
          class="overview-grid"
        >
          <div class="overview-card">
            <div class="overview-detail">
              <div class="overview-data">
                <div
                  v-if="request.createdVacancy"
                  class="overview-data-state"
                  :class="{ done: request.createdVacancy.active === true }"
                  @click="
                    $router.push({
                      name: 'project.edit.sub.job',
                      params: {
                        id: request.createdVacancy.project.id,
                        page: 'jobs',
                        jobid: request.createdVacancy.id
                      }
                    })
                  "
                ></div>
                <div
                  v-else
                  class="overview-data-state"
                  @click="
                    $router.push({
                      name: 'project.edit.sub.job',
                      params: {
                        id: request.createdVacancy.project.id,
                        page: 'jobs',
                        jobid: request.createdVacancy.id
                      }
                    })
                  "
                ></div>
                <div
                  class="overview-data-catgory"
                  @click="
                    $router.push({
                      name: 'project.edit.sub.job',
                      params: {
                        id: request.createdVacancy.project.id,
                        page: 'jobs',
                        jobid: request.createdVacancy.id
                      }
                    })
                  "
                >
                  <p>{{ request.category }}</p>
                </div>
                <div
                  @click="
                    $router.push({
                      name: 'project.edit.sub.job',
                      params: {
                        id: request.createdVacancy.project.id,
                        page: 'jobs',
                        jobid: request.createdVacancy.id
                      }
                    })
                  "
                >
                  <span><i class="fal fa-briefcase"></i></span>
                  <div>{{ request.title }}</div>
                </div>
                <div
                  @click="
                    $router.push({
                      name: 'project.edit.sub.job',
                      params: {
                        id: request.createdVacancy.project.id,
                        page: 'jobs',
                        jobid: request.createdVacancy.id
                      }
                    })
                  "
                >
                  <span><i class="fal fa-building"></i></span>
                  <div>{{ request.company.name }}</div>
                </div>
                <div
                  @click="
                    $router.push({
                      name: 'project.edit.sub.job',
                      params: {
                        id: request.createdVacancy.project.id,
                        page: 'jobs',
                        jobid: request.createdVacancy.id
                      }
                    })
                  "
                >
                  <span><i class="fal fa-map-marker-alt"></i></span>
                  <div>
                    <template v-if="request.startsOn">
                      {{ $d(Date.parse(request.startsOn), "short") }}</template
                    >
                    <template v-else>-</template>
                  </div>
                </div>
                <div
                  class="overview-data-favourites"
                  @click="openPreview(request.id)"
                >
                  <span><i class="fal fa-user"></i></span>
                  <div>
                    <template v-if="request.favourites">
                      {{ request.favourites.length }}
                    </template>
                    <template v-else> 0 </template>
                  </div>
                </div>
                <div
                  v-if="request.isActive !== false"
                  :key="'pen' + request.isActive"
                  class="overview-data-action edit"
                  @click="
                    $router.push({
                      name: 'request.edit',
                      params: { id: request.id }
                    })
                  "
                >
                  <i
                    :key="request.isActive"
                    :class="
                      request.isActive !== false ? 'far fa-pen' : 'far fa-trash'
                    "
                  ></i>
                </div>
                <div
                  v-else
                  :key="'trash' + request.isActive"
                  class="overview-data-action delete"
                  @click="confirmDeleteRequest(request.id)"
                >
                  <i
                    :key="request.isActive"
                    :class="
                      request.isActive !== false ? 'far fa-pen' : 'far fa-trash'
                    "
                  ></i>
                </div>
                <div
                  v-if="request.isActive === false"
                  class="overview-data-action done"
                  @click="() => activate(request.id)"
                >
                  <i class="far fa-times-circle"></i>
                </div>
                <div
                  v-else
                  class="overview-data-action"
                  @click="() => deactivate(request.id)"
                >
                  <i class="far fa-check-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <p>Keine Ergebnisse gefunden</p>
      </template>

      <vs-pagination
        v-if="matcherRequests"
        v-model="currentPage"
        :total="totalPages"
        :max="7"
        icon-pack="fas"
        prev-icon="fa-chevron-left"
        next-icon="fa-chevron-right"
      />
      <RequestPreview />
    </div>

    <div class="page-overview-filter">
      <div class="page-overview-filter-fixed">
        <div style="padding: 0 18px; color: grey">
          Ergebnisse: {{ matcherRequests.total }}
        </div>
        <div
          class="filter-title"
          style="padding: 5px 18px 0"
          :class="{ active: mobileFilterOpen }"
          @click="mobileFilterOpen = !mobileFilterOpen"
        >
          Filter-Center
          <div
            v-if="$apollo.queries.matcherRequests.loading"
            class="loading-animation"
          >
            <i class="fad fa-spinner-third"></i>
          </div>
          <i class="far fa-chevron-down"></i>
        </div>
        <div class="mb-4" style="padding: 0 18px">
          <span class="sm:mb-2 md:mb-3 cursor-pointer clearFilter"
            >Filter zurücksetzen <i class="far fa-sliders-v"></i
          ></span>
        </div>
        <div
          class="page-overview-filter--inputs"
          :class="{ active: mobileFilterOpen }"
        >
          <div class="vx-row" style="padding: 0 18px">
            <div class="vx-col w-full">
              <DataInput
                v-model="filter.companies"
                type="model"
                class="w-full"
                name="company"
                label="Firmensuche"
                multiple
                model-label="
                    name
                    landwehrId"
                :select-label="
                  el => el.name + ' ' + (el.landwehrId ? '- L1' : '')
                "
                gql-filter-type="objectFilter"
                gql-query="companies"
                gql-single-query="company"
                placeholder="Firma"
              />
            </div>
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Kategorie</label>
              <DataInput
                v-model="filter.category"
                type="select"
                :options="[
                  { code: 'AÜ', label: 'AÜ' },
                  { code: 'PV', label: 'PV' },
                  { code: 'SAM', label: 'SAM' }
                ]"
                placeholder="Kategorie"
                name="category"
              />
            </div>
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Bereich</label>
              <DataInput
                v-model="filter.section"
                type="select"
                :options="[
                  { code: 'KFM', label: 'KFM' },
                  { code: 'GEW', label: 'GEW' },
                  { code: 'DIV', label: 'DIV' }
                ]"
                placeholder="Bereich"
                name="section"
              />
            </div>
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Benutzergruppe</label>
              <DataInput
                v-model="filter.userGroups"
                type="model"
                placeholder="Benutzergruppe"
                multiple
                name="group"
                gql-query="userGroups"
              />
            </div>
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Berufe</label>
              <DataInput
                v-model="filter.occupations"
                type="model"
                placeholder="Berufe"
                multiple
                gql-query="occupations"
              />
            </div>
            <div class="vx-col w-full">
              <label class="text-sm opacity-75">Aktiv</label>
              <DataInput
                v-model="filter.isActive"
                type="bool"
                name="isActive"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { agridMixin } from "@/mixins/agridMixin.js";
import { paginationMixin } from "@/mixins/paginationMixin.js";
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";
import RequestPreview from "./RequestPreview";

export default {
  components: {
    DataInput,
    RequestPreview
  },
  mixins: [paginationMixin("matcherRequests"), agridMixin],
  data() {
    return {
      currentPage: 1,
      initReady: false,
      currentFilterPreset: null,
      applicantSkill: null,
      skillFilter: [],
      skillFilterObjects: [],
      sortBy: null,
      sortDesc: false,
      deleteId: null,
      saveFilterName: "",
      mobileFilterOpen: false,
      setDefaultFilter: false,
      filter: {
        category: null,
        section: null,
        userGroups: null,
        companies: null,
        occupations: null,
        isActive: true
      },
      matcherRequests: {},
      deleteRequestId: null
    };
  },
  mounted() {
    if (this.$apollo.requests && this.$apollo.requests.matcherRequests) {
      this.$apollo.requests.matcherRequests.refetch();
    }
  },
  apollo: {
    matcherRequests: {
      query: gql`
        query MatcherRequests(
          $filter: MatcherRequestFilter!
          $page: Int
          $size: Int
        ) {
          matcherRequests(filter: $filter, page: $page, size: $size) {
            total
            page
            results {
              id
              isActive
              title
              section
              category
              startsOn
              company {
                id
                name
                postAddress {
                  city
                }
              }
              query {
                id
              }
              favourites {
                id
              }
              createdVacancy {
                id
                active
                project {
                  id
                }
              }
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          page: Number(this.currentPage),
          size: this.paginationPageSize,
          filter: this.filter
        };
      }
    }
  },
  watch: {
    matcherRequests(value) {
      console.log(value);
    },
    filter: {
      handler() {
        this.$apollo.queries.matcherRequests.refetch();
      },
      deep: true
    }
  },
  methods: {
    openPreview(profileId) {
      this.$router.replace({
        name: "request.preview",
        params: {
          previewid: profileId,
          referer: this.$route.name,
          refererParams: this.$route.params
        }
      });
    },
    confirmDeleteRecord(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei einen Benutzer zu löschen. Wirklich löschen?`,
        accept: this.deleteRecord,
        acceptText: "Löschen"
      });
    },
    confirmDeleteRequest(id) {
      this.deleteRequestId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei eine Anfrage zu löschen. Wirklich löschen?`,
        accept: this.deleteRequest,
        acceptText: "Löschen"
      });
    },
    deleteRequest() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!) {
              deleteMatcherRequest(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteRequestId
          }
        })
        .then(() => {
          this.showDeleteRequestSuccess();
          // TODO: Workaround entfernen und Navigation neu laden lassen, dass der Filter sofort sichtbar wird
          setTimeout(() => {
            this.$apollo.queries.matcherRequests.refetch();
          }, 150);
        });
    },
    deleteRecord() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!) {
              deleteApplicant(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId
          }
        })
        .then(() => {
          this.showDeleteSuccess();
          // TODO: Workaround entfernen und Navigation neu laden lassen, dass der Filter sofort sichtbar wird
          setTimeout(() => {
            window.location.reload();
          }, 150);
        });
    },
    async activate(requestID) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation ActivateMatcherRequest{
            activateMatcherRequest(request:"${requestID}"){
              id
            }
          }
        `
      });
      this.$apollo.queries.matcherRequests.refetch();
    },
    async deactivate(requestID) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation DeactivateMatcherRequest{
            deactivateMatcherRequest(request:"${requestID}"){
              id
            }
          }
        `
      });
      this.$apollo.queries.matcherRequests.refetch();
    },
    showDeleteSuccess() {
      this.deleteId = null;
      this.$vs.notify({
        color: "success",
        title: "Bewerber gelöscht",
        text: "Der ausgewählte Bewerber wurde gelöscht"
      });
    },
    showDeleteRequestSuccess() {
      this.deleteRequestId = null;
      this.$vs.notify({
        color: "success",
        title: "Anfrage gelöscht",
        text: "Die ausgewählte Anfrage wurde gelöscht"
      });
    }
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
<style scoped>
.loading-animation > * {
  display: inline-block !important;
  animation: rotate 1s linear 0s infinite;
}
.loading-animation {
  display: inline-block;
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
</style>
